import { useTranslation } from 'react-i18next';

import { useVenueLanguagePicker } from '~/stores/useVenueLanguagePicker';
import { saveGamepadLang } from '~/utils/gamepadLang';
import { LanguagePickerScreen, selectedGamepadLanguage, showsLanguagePicker } from '~/utils/playerLanguage';

import { LanguageSelector } from './LanguageSelector';

export type PlayerLanguagePickerProps = {
    clientID: string | null | undefined;
    /** Écran où les drapeaux s'affichent (cf. showsLanguagePicker). */
    screen: LanguagePickerScreen;
    /** Appelé après le changement (ex. en partie : prévenir le jeu ouvert). */
    onChanged?: (code: string) => void;
};

/**
 * Drapeaux de langue du téléphone joueur, affichés seulement là où le choix est
 * proposé (cf. showsLanguagePicker : aéroports sur l'écran du pseudo, lieux qui ont
 * allumé l'option dans Mon compte sur les trois écrans).
 * Le choix est gardé sur le téléphone et relu par GamepadApp au chargement.
 */
export function PlayerLanguagePicker({ clientID, screen, onChanged }: PlayerLanguagePickerProps) {
    const { i18n } = useTranslation();
    const venueAllows = useVenueLanguagePicker((s) => s.venueAllows);

    if (!showsLanguagePicker(clientID, venueAllows, screen)) return null;

    const onChange = (code: string) => {
        saveGamepadLang(code, clientID);
        i18n.changeLanguage(code);
        onChanged?.(code);
    };

    return <LanguageSelector value={selectedGamepadLanguage(i18n.language)} onChange={onChange} />;
}
